<template>
    <div class="item-input">
		<div class="thumb" :style="`background-image: url('${localImg}'); border: 3px solid ${modelValue.color}`"></div>
		<div class="field-wrap">
			<input type="text" v-model="localImg" />
			<button v-if="canRemove" class="remove" @click="$emit('remove', modelValue.id)">
				<IconTrash />
			</button>
		</div>
	</div>
</template>

<script>
import { ref, watch } from 'vue'

import IconTrash from './IconTrash.vue'

export default {
    name: "ItemInput",
	components: {
		IconTrash,
	},
    props: {
		modelValue: {
			type: Object, // { id, img, color }
			default: undefined,
		},
		canRemove: {
			type: Boolean,
			default: true,
		}
    },
    setup(props, { emit }) {
		const localImg = ref(props.modelValue.img)

		watch(localImg, () => { emit('update:modelValue', { id: props.modelValue.id, img: localImg.value }) })

        return {
			localImg
        }
    },
};
</script>

<style>
.item-input {
	padding: 8px 0;
	display: flex;
	align-items: center;
	position: relative;
}
.item-input.ghost::before {
	content: "";
	width: 0;
	height: 0;
	border-left: 6px solid black;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	position: absolute;
	left: -10px;
	top: calc(50% - 6px);
}
.item-input .thumb {
	flex: 0 0 40px;
	background-color: #efefef;
	background-size: cover;
	background-position: center;
	width: 40px;
	height: 40px;
	margin-right: 15px;
	border-radius: 40px;
	cursor: ns-resize;
}

.item-input .field-wrap {
	width: 100%;
	height: 40px;
	position: relative;
	overflow: hidden;
	
}
.item-input .field-wrap::after {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border-radius: 4px;
	box-shadow: inset 0 0 3px rgba(0,0,0,0.3);
	pointer-events: none;
}
.item-input input {
	padding: 5px 10px;
	border-radius: 4px;
	border-color: #ccc;
	width: 100%;
	height: 40px;
	border: 0;
}
.item-input .remove {
	position: absolute;
	right: 0;
	top: 0;
	height: 40px;
	width: 40px;
	background: none;
	border: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f1f1f1;
	cursor: pointer;
	transform: translateX(40px);
	transition: transform 150ms ease-out;
}
.item-input:hover .remove {
	transform: none;
}
.is-dragging .item-input .remove,
.item-input.ghost .remove,
.sortable-chosen .remove {
	display: none;
}
.item-input .remove svg {
	opacity: 0.3;
}
.item-input .remove:hover svg {
	opacity: 0.7;
}
.sortable-chosen {
	opacity: 0.5
}
</style>